import { render, staticRenderFns } from "./DoctorRegister.vue?vue&type=template&id=1ff83391"
import script from "./DoctorRegister.vue?vue&type=script&lang=js"
export * from "./DoctorRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports